import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import * as SourceApps from 'automation-ui-source-apps/constants/SourceApps';
import * as AccessTypes from 'automation-ui-action-features/access/constants/AccessTypes';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import getEarlyRequest from 'automation-ui-action-features/utils/getEarlyRequest';
import { UNKNOWN_ID, UNKNOWN, ToObjectType } from 'automation-ui-references/object-types/CRMObjectTypes';
const earlyRequestName = 'object-type-access';
const sourceAppEarlyRequestName = 'source-app-object-type-access';
const appendGoToActionTypeAccess = objectTypeAccess => Object.assign({}, objectTypeAccess, {
  actionTypeAccess: objectTypeAccess.actionTypeAccess.concat({
    actionType: ActionTypes.GO_TO,
    accessLevel: AccessTypes.USER_ACCESS
  })
});
const mapByEnrolledTypeAndObjectTypeId = (result, objectTypeAccess) => {
  var _objectTypeAccess$enr;
  const enrolledType = ((_objectTypeAccess$enr = objectTypeAccess.enrolledType) === null || _objectTypeAccess$enr === void 0 ? void 0 : _objectTypeAccess$enr.type) || 'CRM_OBJECT';
  if (!result[enrolledType]) {
    result[enrolledType] = {};
  }
  if (enrolledType === 'CRM_OBJECT') {
    result[enrolledType][objectTypeAccess.enrolledType.objectTypeId] = objectTypeAccess;
  } else if (enrolledType === 'DATASET') {
    result[enrolledType][objectTypeAccess.enrolledType.datasetId] = objectTypeAccess;
  } else {
    result[enrolledType] = objectTypeAccess;
  }
  return result;
};
const mapByObjectTypeId = objectTypeAccess => {
  var _objectTypeAccess$enr2, _ToObjectType$objectT;
  const objectTypeId = (_objectTypeAccess$enr2 = objectTypeAccess.enrolledType.objectTypeId) !== null && _objectTypeAccess$enr2 !== void 0 ? _objectTypeAccess$enr2 : UNKNOWN_ID;
  return [objectTypeId, {
    accessLevel: objectTypeAccess.accessLevel,
    baselineActionAccessLevel: objectTypeAccess.baselineActionAccessLevel,
    actionTypeAccess: objectTypeAccess.actionTypeAccess,
    objectTypeId,
    flowObjectType: (_ToObjectType$objectT = ToObjectType[objectTypeId]) !== null && _ToObjectType$objectT !== void 0 ? _ToObjectType$objectT : UNKNOWN
  }];
};
const isCrmObjectAccess = access => {
  return access.enrolledType.type === 'CRM_OBJECT';
};
const formatObjectTypeAccessResponse = response => {
  if (!Array.isArray(response)) {
    throw new Error('Unexpected response');
  }
  const objectTypeAccessById = Object.fromEntries(response.map(appendGoToActionTypeAccess).filter(isCrmObjectAccess).map(mapByObjectTypeId));
  const objectTypeAccessByEnrolledType = response.map(appendGoToActionTypeAccess).reduce(mapByEnrolledTypeAndObjectTypeId, {});
  return {
    objectTypeAccessById,
    objectTypeAccessByEnrolledType
  };
};
export const GET_ACCESS_BY_OBJECT_TYPE_ID = registerQuery({
  fieldName: 'accessByObjectTypeId',
  fetcher: ({
    flowSourceApp
  }) => {
    if (flowSourceApp === SourceApps.WORKFLOWS_APP) {
      return getEarlyRequest({
        defaultRequestFn: () => http.get('automationplatform/v1/access/object-enrolled-type-access'),
        key: earlyRequestName
      }).then(formatObjectTypeAccessResponse);
    }
    return getEarlyRequest({
      defaultRequestFn: () => http.get(`automationplatform/v1/access/object-enrolled-type-access?sourceApp=${flowSourceApp}`),
      key: sourceAppEarlyRequestName
    }).then(formatObjectTypeAccessResponse);
  }
});